import { Component } from '@angular/core';
import { LcsChipGridComponentBase } from 'src/app/common-components/chip-grid/chip-grid';
import { DepartmentOption } from 'src/app/pages/extension-register/models/extension-option.interface';

@Component({
    selector: 'ndt-department-chip-grid',
    templateUrl: 'department-chip-grid.component.html',
    standalone: false
})
export class DepartmentChipGridComponent extends LcsChipGridComponentBase<DepartmentOption> {
   trackBy(item: DepartmentOption | null) {
      return item?.departmentId;
   }
}
